module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "home row row-eq-height"
  }, [_c('div', {
    staticClass: "col-sm-4 image"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.homeData.image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 introduction"
  }, [_c('h1', [_vm._v(_vm._s(_vm.homeData.title))]), _vm._v(" "), _vm._l((_vm.homeData.introduction), function(paragraph) {
    return _c('p', [_vm._v(_vm._s(paragraph))])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b1a5504","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 385
// module chunks = 1